
  Vue.component('widget-configurator', {
    props: {
      qrcUrl: { type: String, default: '/api/v1/qrcode/get-image?qrcv=1' },
      printMode: { type: Boolean, default: false },
      managerMode: { type: Boolean, default: true },
      showHeader: { type: Boolean, default: true },
      size: { type: String, default: '' }
    },
    data() {
      return {
        idList: 0,
        formatType: 3,
        linkType: -1,
        autoPrint: false,
        show: true,
        currentPage: 1,
        seekerId: null,
        seekerLogoUrl: null,
        seekerName: 'LearK',
        seekerCompanySign: '',
        entityType: 1,
        printFormat: '15x15',
        customPrintParameters: null
      }
    },
    template: '#widget-configurator',
    computed: {
      title() {
        return this.seekerCompanySign && this.seekerCompanySign !== this.seekerName
          ? this.seekerCompanySign
          : this.seekerName
      },
      subTitle() {
        return this.seekerCompanySign && this.seekerCompanySign !== this.seekerName ? `di ${this.seekerName}` : ''
      },
      pageHeader() {
        let retVal = {
          title: 'Configura il tuo QRCode',
          subTitle: 'Modifica le opzioni e scarica il QRCode nel formato che preferisci.'
        }
        if (!this.managerMode) {
          retVal = {
            title: 'Ottieni il QR Code da stampare o condividere.',
            subTitle: 'Il widget a portata di smartphone.'
          }
        }
        return retVal
      },
      pages() {
        const retVal = [
          {
            id: 1,
            code: 'customize',
            label: 'Personalizza',
            title: 'Personalizza il tuo widget',
            subTitle: '',
            buttonStyle: 'primary',
            titleIcon: 'fa-users-medical fa-swap-opacity'
          },
          {
            id: 2,
            code: 'advanced',
            label: 'Avanzate',
            title: 'Configurazioni avanzate',
            subTitle: '',
            buttonStyle: 'primary',
            titleIcon: 'fa-users-cog'
          },
          {
            id: 3,
            code: 'list',
            label: 'Liste',
            title: 'Gestisci le liste',
            subTitle: '',
            buttonStyle: 'primary',
            titleIcon: 'fa-users-cog'
          },
          {
            id: 4,
            code: 'complete',
            label: 'Crea',
            title: 'Installa il tuo widget o genera il QR Code',
            subTitle: '',
            buttonStyle: 'success',
            titleIcon: 'fa-users-cog'
          }
        ]
        return retVal.sort((a, b) => (a.id > b.id ? 1 : -1))
      },
      sideMessage() {
        const rightMessage = 'carica il tuo cv'
        const leftMessage = 'lavora con noi'
        const defaultMessage = { leftMessage, rightMessage }
        const messageList = [
          { entityType: 1, ...defaultMessage },
          { entityType: 2, ...defaultMessage, leftMessage: 'facciamo rete' },
          { entityType: 3, ...defaultMessage },
          { entityType: 5, ...defaultMessage, leftMessage: 'diventa volontario' }
        ]
        return messageList.filter(item => item.entityType === this.entityType)[0]
      },
      selectedLinkType() {
        return this.linkTypesList.find(x => x.id === this.linkType)
      },
      selectedPage() {
        return this.pages.find(x => x.id === this.currentPage)
      }
    },
    watch: {},
    methods: {
      handlePage(e, page) {
        this.currentPage = page
        saveWidgetConfiguration(this.currentPage === this.pages.length)
      },
      getSeekerData() {
        const self = this
        axios
          .get(`/api/v1/seeker/`)
          .then(response => {
            const { data: seeker } = response
            self.seekerLogoUrl = seeker.imageLogoUrl
            self.seekerName = seeker.name
            self.seekerCompanySign = seeker.companySign
            self.entityType = seeker.entityType
            if (self.autoPrint) setTimeout(() => self.printPdfQrCode(), 400)
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            // always executed
          })
      },
      changeIdList(idList) {
        this.idList = idList
      }
    },
    mounted() {
      EventBus.$emit('widget-configurator-load')
    },

    beforeDestroy() {}
  })
